import Vue from "vue";
import AddToCalendar from "vue-add-to-calendar";

Vue.use(AddToCalendar);
